import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import { withContainer } from 'core/cache';
import removeModal from '../helpers/removeModal';
import { Modal } from 'uikit/modals';

const ModalContainer = createReactClass({
  propTypes: {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    modal: PropTypes.shape({
      actions: PropTypes.arrayOf(PropTypes.shape({})),
      commitAction: PropTypes.func,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      shouldModalCloseOnNavigation: PropTypes.bool,
      isFocusLockDisabled: PropTypes.bool,
      ariaLabel: PropTypes.string,
    }).isRequired,
    notificationsModalsById: PropTypes.shape({
      data: PropTypes.shape({}),
      set: PropTypes.func,
    }).isRequired,
  },

  getDefaultProps() {
    return {
      modal: {
        ariaLabel: '',
        isFocusLockDisabled: false
      }
    }
  },

  getInitialState() {
    return {
      hasFormLoaded: false,
    };
  },

  componentDidUpdate(prevProps) {
    const { location, modal } = this.props;

    if (prevProps.location.pathname !== location.pathname && modal.shouldModalCloseOnNavigation !== false) {
      removeModal();
    }
  },

  onActionClicked({ action, callback }) {
    const { modal, notificationsModalsById } = this.props;
    const response = { type: action, payload: notificationsModalsById.data[modal.id] };

    if (callback) return callback(response);

    modal.commitAction(response);
  },

  onFormUpdate({ update, hasError, formState }) {
    const { modal, notificationsModalsById } = this.props;
    const { id } = modal;
    const data = { ...notificationsModalsById.data[id], ...update };

    this.hasFormError = hasError;
    this.formState = formState;
    notificationsModalsById.set({ [id]: data }, { setType: 'extend' });
  },

  onFormLoad({ hasError, formState }) {
    this.hasFormError = hasError;
    this.formState = formState;
    this.setState({
      hasFormLoaded: true,
    });
  },

  onCloseButtonClicked() {
    const { modal } = this.props;
    const callback = modal.actions?.find(({ action }) => action === 'CLOSE')?.callback;

    this.onActionClicked({ action: 'CLOSE', callback });
  },

  hasFormError: false,

  formState: {},

  render() {
    const { modal, notificationsModalsById } = this.props;
    const modalData = notificationsModalsById.data[modal.id];

    return (
      <Modal
        modal={modal}
        modalData={modalData}
        formState={this.formState}
        hasFormLoaded={this.state.hasFormLoaded}
        hasFormError={this.hasFormError}
        onActionClicked={this.onActionClicked}
        onFormUpdate={this.onFormUpdate}
        onFormLoad={this.onFormLoad}
        onCloseButtonClicked={this.onCloseButtonClicked}
        isFocusLockDisabled={modal.isFocusLockDisabled}
        ariaLabel={modal.ariaLabel}
        closeButtonAriaLabel={modal.closeButtonAriaLabel}
      />
    );
  },
});

export default withContainer(ModalContainer, {
  hasRouter: true,
  cache: {
    notificationsModalsById: {
      isListener: true,
    },
  },
});
